module.exports = __webpack_public_path__ + "assets/img/poster-hire_01.e6e7c163.jpg";